import SearchFlowProgressBar from "../searchFlowProgressBar/SearchFlowProgressBar.jsx";
import SearchFlowFooter from "./SearchFlowFooter.jsx";
import shellClasses from "./searchFlowFooterShell.module.scss";

const SearchFlowFooterShell = ({
  progress,
  footerNav,
  isTransitioning = false,
  footerCenterContent = null,
}) => {
  if (!progress && !footerNav) {
    return null;
  }

  const footerProps = footerNav || {};

  return (
    <div className={shellClasses.shell}>
      {progress ? (
        <div className={shellClasses.progressRow}>
          <SearchFlowProgressBar value={progress.value} />
        </div>
      ) : null}
      {footerNav ? (
        <div className={shellClasses.navRow}>
          <div className={shellClasses.navRowInner}>
            <SearchFlowFooter
              {...footerProps}
              embedded
              isTransitioning={isTransitioning}
              centerContent={footerCenterContent}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SearchFlowFooterShell;
